/// <amd-module name="Reporting/BoardsReportView/PlaceholderBoardUnsupportedError" />
import { Board } from "Analytics/Boards/CumulativeFlowDiagramQueries/BoardsQuery";
import { WidgetTeamContext } from "Dashboards/WidgetContracts/WidgetProps";
import * as Resources from "Reporting/BoardsReportView/Resources";
import { format } from "VSS/Core/Util/String";

export class PlaceholderBoardUnsupportedError extends Error {
    // @ts-ignore - Silencing "TS6133: Build: '__proto__' is declared but its value is never read."
    private __proto__: Error;

    public projectId: string;
    public team: WidgetTeamContext;
    public board?: Board;

    public constructor(projectId: string, team: WidgetTeamContext, board?: Board) {
        const trueProto = new.target.prototype;

        super(format(Resources.Error_PlaceholderBoardUnsupported_Format, board ? board.BoardName : ""));

        this.projectId = projectId;
        this.team = team;
        this.board = board;

        /**
         * Used to support instanceof with custom errors.
         * TypeScript prototypes don't transpile correctly for certain built-in types like Error and Array.
         * However by explicitly setting the prototype the functionality is restored.
         * Subtypes of this custom error must also use this same workaround.
         * Can't use Object.setPrototypeOf because our headless browser used for unit tests doesn't support it.
         * https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
         */
        this.__proto__ = trueProto;
    }
}
